import { Component, inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { I18nMissCatcherService } from "@app/i18n-miss-catcher/i18n-miss-catcher.service";
import { ClientConfigService } from "@app/shared/services/client-config.service";
import { EffectiveLanguageService } from "@app/shared/services/effective-language.service";
import { ObservabilityService } from "@app/shared/services/observability.service";
import { isPseudoEnabled, setPseudoEnabled } from "@app/lang-override";

// Dev-only navbar plugin: the toggle + capture panel for the i18n miss-catcher, plus the
// pseudo-locale checkbox. Rendered only in non-prod (guarded in the template); all capture
// logic lives in the injected service, this component is just its presentation in the top bar.
// The profile page stays the leading, user-facing way to pick a real language: unchecking
// pseudo here falls back to that normal profile/tenant-default/English flow, never a raw
// language list.
@Component({
    selector: "app-navbar-i18n-feedback",
    templateUrl: "./navbar-i18n-feedback.component.html",
    styleUrls: ["../navbar-plugin-base.scss", "./navbar-i18n-feedback.component.scss"],
})
export class NavbarI18nFeedbackComponent {
    protected readonly missCatcher = inject(I18nMissCatcherService);
    protected readonly i18nToolingEnabled = inject(ClientConfigService).i18nToolingEnabled;
    protected readonly observability = inject(ObservabilityService);
    private readonly transloco = inject(TranslocoService);
    private readonly effectiveLanguageService = inject(EffectiveLanguageService);

    protected pseudoEnabled = isPseudoEnabled();

    protected togglePseudo(): void {
        this.pseudoEnabled = !this.pseudoEnabled;
        setPseudoEnabled(this.pseudoEnabled);

        if (this.pseudoEnabled) {
            this.transloco.setActiveLang("pseudo");
        } else {
            this.effectiveLanguageService.apply();
        }
    }

    protected submitToSentry(): void {
        this.missCatcher.submitToSentry();
    }
}
